module.exports = __webpack_public_path__ + "e60af6584a0d5edd9deff36e96241998.svg";